import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { Load } from 'types/Load';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type CancelLoadResult = {
  load: Load;
  message?: string;
};

export async function cancelLoad(
  loadId: number
): Promise<Result<CancelLoadResult, ApiError>> {
  try {
    const response = await axios.post<CancelLoadResult>(
      `/load/${loadId}/cancel`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'cancelLoad' });

    if (!isAxiosError(error)) {
      return err({
        message: 'Unable to cancel load.',
      });
    }

    if (error.response?.status === 401) {
      throw error;
    }

    if (error.message === 'Extension context invalidated.') {
      throw error;
    }

    return err({
      message: error.response?.data?.message || 'Unable to cancel load.',
      load: error.response?.data?.load,
    });
  }
}
